import { render, staticRenderFns } from "./QueuedContacts.vue?vue&type=template&id=84e63b3a&scoped=true&"
import script from "./QueuedContacts.vue?vue&type=script&lang=js&"
export * from "./QueuedContacts.vue?vue&type=script&lang=js&"
import style0 from "./QueuedContacts.vue?vue&type=style&index=0&id=84e63b3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e63b3a",
  null
  
)

export default component.exports